import { Injectable, ViewContainerRef } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { ColorFlyoutData, ColorFlyoutMenuComponent } from './color-flyout-menu.component';

@Injectable({
  providedIn: 'root',
})
export class ColorFlyoutMenuService {
  constructor(private dialogService: MatLegacyDialog) {}

  public open(
    data: ColorFlyoutData,
    container: ViewContainerRef,
    position: { top: string | undefined; left: string | undefined }
  ) {
    return this.dialogService.open(ColorFlyoutMenuComponent, {
      backdropClass: 'mode-backdrop',
      data,
      viewContainerRef: container,
      panelClass: 'flyout-dialog',
      autoFocus: false,
      width: 'auto',
      position: { top: position.top, left: position.left },
      enterAnimationDuration: '10ms',
    });
  }
}
